function addThousandsSeparator(value: string) {
	return value.replace(/\d(?=(\d{3})+\.)/g, '$&,')
}

export default function formatMoney(balance: number | null): string {
	if (balance == null || balance === 0) return '0.00'

	if (Math.abs(balance) < 10) {
		const fourPlaces = balance.toFixed(4)
		if (fourPlaces.slice(-2) === '00') return balance.toFixed(2)
		return fourPlaces
	}

	return addThousandsSeparator(balance.toFixed(2))
}
